require('dotenv').config();

export const URL_SERVICIOS_LOCALES =  process.env.URL_SERVICIOS_LOCALES || "http://138.121.170.105:4001"
export const URL_SERVICIOS_LOCALES_IMPRESORA = process.env.URL_SERVICIOS_LOCALES_IMPRESORA || "http://localhost:2347/print"
export const URL_SERVICIOS_LOCALES_CORREO = process.env.URL_SERVICIOS_LOCALES_CORREO || "http://138.121.170.105:4001/correo"
export const MODO_DESCONECTADO = false
export const RUTA_MODO_DESCONECTADO = 'c:\\bd\\'
export const VERSION = '37.0.10'
export const NOMBRE_VERSION = 'SAN'
export const DESCRIPCION_VERSION = ''
export const GESTION_PEDIDOS_SALON = false
export const GESTION_DOMICILIOS = false
export const URL_SERVICIOS_LOCALESFRONT = process.env.URL_SERVICIOS_LOCALESFRONT || "http://138.121.170.105:8100"
export const URL_SERVICIOS_LOCALESBACK = process.env.URL_SERVICIOS_LOCALESBACK || "D:\\Victor\\Personal\\big-data\\Proyecto\\SAN\\SART-WWW-DEV\\assets\\"
export const PRODUCCION = false;
export const URL_SERVICIOS_AWS = "https://oxbygdxgzb.execute-api.us-east-1.amazonaws.com/dev"
export const URL_SERVICIOS_AWS_IMAGE="https://15pcy9cqye.execute-api.us-east-1.amazonaws.com"
export const NUBE_AWS = true
export const URL_DIAN_DOCUMENTO = 'https://apps.kiai.co/api/ConValidacionPrevia/EmitirDocumento'
export const URL_DIAN_CREAR_SET_PRUEBA = 'https://apps.kiai.co/api/ConValidacionPrevia/CrearSetPrueba/'
export const URL_DIAN_RESUMEN_SUSCRIPTOR = 'https://apps.kiai.co/api/ConValidacionPrevia/ResumenSuscriptor/'
export const URL_DIAN_PDF= 'https://apps.kiai.co/api/Mediador/ObtenerRepresentacionVpGenericaAsync/'
export const URL_ARCHIVO_AWS = 'https://pj1gseqyc0.execute-api.us-east-1.amazonaws.com/dev/image-upload';

export const DEETDMRCSP_POS_URL_CREAR_SET_PRUEBA = 'https://apps.kiai.co/api/DocumentoEquivalente/crearsetprueba'
export const DEETDMRCSP_POS_URL_DIAN_DOCUMENTO = 'https://apps.kiai.co/api/DocumentoEquivalente/EmitirDocumento'
export const DEETDMRCSP_POS_NOMBRE_APELLIDO = 'ANDRES NARANJO'
export const DEETDMRCSP_POS_RAZON_SOCIAL = 'natural'
export const DEETDMRCSP_POS_NOMBRE_SOFTWARE = 'SAN'
export const DEETDMRCSP_POS_NIT = '15373234'
export const URL_PRINT_GLOBAL_PORT = '2348'
export const URL_ELECTRON_GLOBAL_PORT = '2349'
export const URL_ELECTRON_IP = 'localhost'
export const URL_REDIRECT_IONIC7 = 'https://pedidossalon.s3.amazonaws.com/index.html'
export const URL_SQS_AWS = "https://hclnp7w5u0.execute-api.us-east-1.amazonaws.com/dev"
export const URL_IA = "https://2o0csw7y58.execute-api.us-east-1.amazonaws.com/consultarBD"
export const WHATSAPP_TOKEN = "EAAJLpdQokNoBOZBYw1rhaCMePDasVtZA7I99sLhxV7EZBLIO2MvabSrWYqgd95NtcZBgZBPABZCJeP92fPnh1CFB4BTms2pNs9i7tVEeDp7qNvUKTHnRdxQTIQxI8uSIsdQnGM5dr8dgIaaBYLnC5bnH7SyZANN4lmZBu2AiuaXR9qx0uZCsHa8tu354HJ4Ps58hFygZDZD"
export const URL_WHATSAPP = "https://graph.facebook.com/v21.0/539956119197778/messages"



// WEBPACK FOOTER //
// ./src/config/url.servicio.ts